import axios from "axios";
import * as Cookies from "js-cookie";
import store from "@/store";

export default {
  state: {
    token: null,
    user: {},
    userDetails: {},
    registerDetails: {},
    trainerCompleteSignup: [],
    userCompleteSignup: [],
    trainerPaypalEmail: [],
    postSubscribe: [],
    accountValidate: [],
    guestDetails: {},
    timezoneDetails: [],
  },

  getters: {
    getToken(state) {
      return state.token;
    },
    getUser(state) {
      return state.user;
    },
    userDetails(state) {
      return state.userDetails;
    },
    registerDetails(state) {
      return state.registerDetails;
    },
    trainerCompleteSignup(state) {
      return state.trainerCompleteSignup;
    },
    userCompleteSignup(state) {
      return state.userCompleteSignup;
    },
    trainerPaypalEmail(state) {
      return state.trainerPaypalEmail;
    },
    postSubscribe(state) {
      return state.postSubscribe;
    },
    accountValidate(state) {
      return state.accountValidate
    },
    guestDetails(state) {
      return state.guestDetails;
    },
    getTimezoneDetails(state) {
      return state.timezoneDetails;
    },
  },

  actions: {
    async register({ commit }, payload) {
      try {
        const response = await axios.post("beta-register", payload);
        const data = response.data && response.data.data;
        store.commit("setIsSuccess", response.data.message);
        const expirationDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
        Cookies.set("token", data.token, { expires: expirationDate });
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("details", JSON.stringify(data.personal_details));
        commit("setRegisterDetails", data);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }

    },

    async becomeTrainerFromUser({ commit }, payload) {
      try {
        const res = await axios.post("user/become-trainer", payload);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        return res && res.data && res.data.data;
      } catch (e) {
        store.commit("setIsLoading", false);
        const error = {
          title: "Error occured",
          text:
            e.response &&
            e.response.data &&
            e.response.data.message || e.message,
        };
        store.commit("setError", error);
        throw e;
      }
    },

    async becomeTrainerDirectly({ commit }, payload) {
      const res = await axios.post("trainer/become-trainer", payload);
      const data = res.data && res.data.data;

      localStorage.setItem('details', JSON.stringify(data.personal_details))
      store.commit("setIsSuccess", res && res.data && res.data.message);
    },

    async signupVerification({ commit }, data) {
      const response = await axios.post(`/signup/verification`, data);

      const user =
        response.data && response.data.data && response.data.data.user;
      commit("setUserDetails", user);
    },

    async verifyEmail({ commit }, userToken) {
      const response = await axios.get(`/verify/${userToken}`);

      const token =
        response.data && response.data.data && response.data.data.token;
      const user =
        response.data && response.data.data && response.data.data.user;
      const details =
        response.data &&
        response.data.data &&
        response.data.data.personal_details;

      commit("setUserDetails", { token, user, details });
    },

    async trainerCompleteSignup({ commit }, data) {
      const res = await axios.post("/trainer/complete/signup", data);

      const newData = res && res.data && res.data.data;
      commit("setTrainerCompleteSignup", newData);
    },

    async userCompleteSignup({ commit }, data) {
      const res = await axios.post("/user/complete/signup", data);

      const newData = res && res.data && res.data.data;
      commit("userCompleteSignup", newData);
    },

    async resendVerificationEmail({ commit }, payload) {
      const res = await axios.post("/resendemail", payload);

      store.commit("setIsSuccess", res && res.data && res.data.message);
    },

    async trainerPaypalEmail({ commit }, data) {
      const res = await axios.post("/trainer/update/paypal-email", data);

      store.commit("setIsSuccess", res && res.data && res.data.message);
      const newData = res && res.data && res.data.data;
      commit("setTrainerPaypalEmail", newData);
    },

    async findGuestUser({ commit }, userId) {
      const res = await axios.get(`/find/guest-user/${userId}`);
      let newData = res && res.data && res.data.data && res.data.data.user;

      commit("setGuestDetails", newData);
    },

    async guestCompleteSignup({ commit }, data) {
      const res = await axios.post("complete/guest-signup", data);
      const token = res.data && res.data.data && res.data.data.token;
      const user = res.data && res.data.data && res.data.data.user;
      // const details = res.data && res.data.data && res.data.data.personal_details;

      Cookies.set("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      // commit("setUserDetails", { token, user, details });
    },

    async postSubscribe({ commit }, payload) {
      const res = await axios.post("subscribe", payload);
      store.commit("setIsSuccess", res && res.data && res.data.message);

      const data = res && res.data && res.data.data;
      commit("setPostSubscribe", data);
    },

    async postAccountValidate({ commit }, payload) {
      const res = await axios.post("account-validate", payload);

      const data = res && res.data && res.data.data;
      commit("setAccountValidate", data);
    },

    async timezone({ commit }) {
      const res = await axios.get(`/timezone`);
      const data = res && res.data;
      commit("setTimezone", data.data);
    },

    async updateTimezoneForUser({ commit }, payload) {
      try {
        const res = await axios.post(`user/update-timezone/${payload}`);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        store.commit("setIsLoading", false);
      } catch (e) {
        const error = {
          title: "Error occured",
          text:
            e.response &&
            e.response.data &&
            e.response.data.data &&
            e.response.data.data.message,
        };
        store.commit("setError", error);
        store.commit("setIsLoading", false);
      }
    },
    async updateTimeZoneData({commit}, payload) {
      try {
        const res = await axios.put('/update-timezone', {
          timezone: payload
        });
        return res && res.data;
      } catch(err) {
        console.log(err);
        throw err;
      }
    }
  },

  mutations: {
    setUserDetails(state, data) {
      state.userDetails = data;
    },
    setRegisterDetails(state, data) {
      state.registerDetails = data;
    },
    setTrainerCompleteSignup(state, data) {
      state.trainerCompleteSignup = data;
    },
    userCompleteSignup(state, data) {
      state.userCompleteSignup = data;
    },
    setTrainerPaypalEmail(state, data) {
      localStorage.setItem("user", JSON.stringify(data));
      state.trainerPaypalEmail = data;
    },
    setPostSubscribe(state, data) {
      state.postSubscribe = data;
    },
    setAccountValidate(state, data) {
      state.accountValidate = data;
    },
    setGuestDetails(state, data) {
      state.guestDetails = data;
    },
    setTimezone(state, data) {
      state.timezoneDetails = data;
    },
  },
};